import { RemittanceForm, RemittanceList } from './components'
import { useRemittanceForm, useMedicalAidPaymentList } from './hooks'

export { RemittanceForm, RemittanceList, useRemittanceForm, useMedicalAidPaymentList }

export default {
  RemittanceForm,
  RemittanceList,
  useRemittanceForm,
  useMedicalAidPaymentList
}
